import React from "react";
import { useLanguage } from "../context/LanguageContext";
import "../styles/BookingClosed.scss";

const BookingClosed = () => {
  const { t } = useLanguage();

  return (
    <section className="booking-closed">
      <div className="booking-closed__grid">
        <div className="booking-closed__content">
          <p className="booking-closed__eyebrow">
            {t("bookingClosed.eyebrow", "Wayli status")}
          </p>
          <h1>{t("bookingClosed.title", "We are currently closed")}</h1>
          <p className="booking-closed__lead">
            {t(
              "bookingClosed.lead",
              "The water is calm, and we are taking a short break to reset. Your existing bookings stay valid, and we will reopen with fresh slots soon."
            )}
          </p>
          
        </div>
       
        <div className="booking-closed__art" aria-hidden="true">
          <img src="/assets/sup1.png" alt="" loading="lazy" />
        </div>
      </div>
    </section>
  );
};

export default BookingClosed;
